export enum ESymbolsHighlighterPhases {
    DYNAMIC_CYCLE_PHASE = 'DYNAMIC_CYCLE_PHASE',
    TRANSITION_CYCLE_PHASE = 'TRANSITION_CYCLE_PHASE',
    NORMAL_CYCLE_PHASE = 'NORMAL_CYCLE_PHASE'
}
